import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const RotatingPhoto = ({ images, interval = 4000, ratio = "aspect-[3/4]", className = "", label, showDots = true }) => {
  const [i, setI] = useState(0);
  const list = (images || []).filter(Boolean);

  useEffect(() => {
    if (list.length < 2) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const t = setInterval(() => setI((v) => (v + 1) % list.length), interval);
    return () => clearInterval(t);
  }, [list.length, interval]);

  if (!list.length) return null;

  return (
    <div
      className={`group relative overflow-hidden ${ratio} ${className}`}
      data-testid="rotating-photo"
      data-cursor="NEXT"
      onClick={() => setI((v) => (v + 1) % list.length)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && setI((v) => (v + 1) % list.length)}
      aria-label="Ganti foto"
    >
      <AnimatePresence mode="popLayout">
        <motion.img
          key={list[i]}
          src={list[i]}
          alt={label || "Dokumentasi Kin Hakan"}
          loading="lazy"
          initial={{ opacity: 0, scale: 1.04 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="absolute inset-0 h-full w-full object-cover object-[center_20%]"
        />
      </AnimatePresence>
      {showDots && list.length > 1 && (
        <div className="absolute bottom-3 left-1/2 flex -translate-x-1/2 gap-1.5">
          {list.map((_, d) => (
            <span key={d} className={`h-1 rounded-full transition-all duration-500 ${d === i ? "w-5 bg-ember" : "w-1 bg-white/50"}`} />
          ))}
        </div>
      )}
      {label && (
        <span className="absolute left-3 top-3 bg-ink/70 px-2.5 py-1 font-display text-[9px] font-bold uppercase tracking-[0.25em] text-paper">
          {label}
        </span>
      )}
    </div>
  );
};

export default RotatingPhoto;
